import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';
import styles from './CookiePolicyPage.module.css';

export function CookiePolicyPage() {
  usePageTitle('Cookie policy');
  return (
    <main className={styles.page}>
      <h1 className={styles.heading}>Cookie Policy</h1>

      <section className={styles.section}>
        <h2 className={styles.sectionHeading}>What we use</h2>
        <p>
          Loupe sets a single cookie when you sign in. That's it. No analytics
          cookies, no tracking pixels, no third-party cookies of any kind.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionHeading}>The cookie</h2>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Purpose</th>
              <th>Lifetime</th>
              <th>Attributes</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><code>session_id</code></td>
              <td>Strictly necessary</td>
              <td>Authentication session identifier — keeps you signed in</td>
              <td>
                Browser session (cleared when you close your browser) + 24h
                inactivity expiry server-side
              </td>
              <td>HttpOnly, Secure, SameSite=Lax</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionHeading}>Can I decline it?</h2>
        <p>
          No. The session cookie is strictly necessary for Loupe to function. If
          it were removed you simply couldn't sign in. We don't set it until you
          actively choose to log in, and it disappears when you close your
          browser.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionHeading}>What we don't use</h2>
        <p>
          No analytics cookies. No advertising or remarketing cookies. No
          third-party cookies. We have no interest in tracking you around the
          internet.
        </p>
      </section>

      <section className={styles.section}>
        <p>
          For details on how we handle your data more broadly, see our{' '}
          <Link to="/privacy">Privacy Notice</Link>.
        </p>
      </section>
    </main>
  );
}
